import styled from 'styled-components';

export const ActionsList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  flex: 1;
`;

export const ActionButton = styled.button`
  width: 100%;
  padding: 12px 16px;
  background: ${(props) =>
    props.theme.name === 'dark' ? 'rgba(255,255,255,0.05)' : 'white'};
  border: 1px solid
    ${(props) =>
      props.theme.name === 'dark'
        ? props.theme?.colors?.['border-button'] || 'rgba(255,255,255,0.15)'
        : props.theme?.colors?.textGray?.muted || '#94a3b8'};
  border-radius: 8px;
  color: ${(props) =>
    props.theme.name === 'dark'
      ? '#94a3b8'
      : props.theme?.colors?.textGray?.muted || '#64748b'};
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: background 0.15s ease, border-color 0.15s ease, color 0.15s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
  position: relative;

  svg {
    width: 16px;
    height: 16px;
    flex-shrink: 0;
  }

  &:hover:not(:disabled) {
    background: ${(props) =>
      props.theme.name === 'dark'
        ? 'rgba(250, 70, 22, 0.15)'
        : 'rgba(250,70,22,0.05)'};
    border-color: ${(props) => props.theme?.colors?.primary || '#fa4616'};
    color: ${(props) => props.theme?.colors?.primary || '#fa4616'};

    svg {
      color: ${(props) => props.theme?.colors?.primary || '#fa4616'};
    }
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;
